import React from "react";
import { Offcanvas } from "react-bootstrap";

interface HowReviewsWorksProps {
  show: boolean;
  onHide: () => void;
}

const HowReviewsWorks: React.FC<HowReviewsWorksProps> = ({ show, onHide }) => {
  return (
    <Offcanvas
      show={show}
      onHide={onHide}
      placement={"end"}
      style={{ width: "500px" }}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          <h3 className="settings-header">How Recipients are prompted to leave a review</h3>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div>
          Once Memorique gathers your recipient's preferences, we'll kindly invite them to leave a review on one of your platforms. They'll also have the option to share the same review across any additional platforms you provide.
        </div>
        <div className="mt-3 text-center w-full">
          <img className="w-[70%] d-block mx-auto" src="/how-it-works.jpeg" />
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default HowReviewsWorks;
